@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-box-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.boxContext"
                [box]="_context.boxContext.box"
                (boxUpdated)="onBoxUpdated($event)"
                (canceled)="onCanceled($event)"></app-box-form>
        </mat-tab>
        @if (!!_context.boxContext.box.id && displayAccessibilities) {
            <mat-tab label="Accessibilité">
                <app-box-accessibility
                    [box]="_context.boxContext.box"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                    (canceled)="onCanceled($event)"></app-box-accessibility>
            </mat-tab>
        }
    </mat-tab-group>
}
